import { HttpContextToken } from "@angular/common/http";

export const SUPPRESS_ERROR = new HttpContextToken(() => false);

export const SUPPRESS_ERROR_CODES = new HttpContextToken<Set<number>>(() => new Set());
